import { createFileRoute } from '@tanstack/react-router';

import { PublicProposalRoutePage } from './-PublicProposalRoutePage';

export const Route = createFileRoute('/_app/proposal/$uuid/')({
  component: PublicProposalRoutePage,
});
